export default function ProductSkeletonCard() {
    return (
      <div className="p-6 flex flex-col items-center">
        <div className="relative w-full md:w-72">
          <div className="w-full bg-gray-100 animate-pulse rounded" style={{ aspectRatio: '4 / 5' }} />
        </div>
        <div className="mt-4 w-40 h-4 bg-gray-100 animate-pulse rounded" />
        <div className="mt-2 w-24 h-4 bg-gray-100 animate-pulse rounded" />
      </div>
    );
  }
  